var map = {
	"./apk.png": 5168,
	"./down.png": 5178,
	"./else.png": 5815,
	"./excel.png": 1480,
	"./img.png": 657,
	"./ipa.png": 1590,
	"./mp4.png": 6087,
	"./pdf.png": 4503,
	"./word.png": 1737,
	"./zip.png": 5084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6442;